<template>
    <div class="block2">
        <div class="page-box-layout">
            <h2 data-aos="fade-down">Artists</h2>
            <p data-aos="fade" class="title">来自秀动发行的艺术家们</p>
            <div class="artist-list">
                <div data-aos="fade" class="artist" v-for="(artist, index) in artists" :key="index">
                    <el-image :src="`${$store.state.config.imageUrl}${artist.artistImage}`" fit="cover"></el-image>
                    <p>{{ artist.artistName }}</p>
                </div>
            </div>
            <div class="btn-box">
                <div class="text">x Release</div>
                <router-link class="btn" :to="userInfo ? '/manage/dashboard' : '/login'">加入秀动发行</router-link>
            </div>
        </div>
    </div>
</template>
<script>
export default {
    data() {
        return {
            artists: [],
        };
    },
    computed: {
        userInfo() {
            return this.$store.state.userInfo;
        },
    },
    created() {
        this.getArtist();
    },
    methods: {
        async getArtist() {
            const { preview } = this.$route.query;
            const respnonse = await this.$request({
                url: '/banner/cp/artist/list',
                params: { status: preview && preview === 'draft' ? 0 : 1 },
                method: 'GET',
            });
            const { state, msg, result } = respnonse.data;
            if (!state) return this.$message.error(msg || '获取艺术家列表失败');
            this.artists =
                result.length > 0
                    ? result
                    : [
                        { artistImage: '/0513/M00/4E/04/ChAKCGTbGbGASbRYAADdV9dyUOg698.jpg', artistName: '邓典果DDG' },
                        { artistImage: '/0513/M00/DC/3E/ChAKFGTbGfWARGnXAAC-tWpoA_A110.jpg', artistName: 'SSR STUDIO' },
                        { artistImage: '/0513/M00/DC/3E/ChAKFGTbGhSAYrV6AAB3dmbl9n0882.jpg', artistName: '张泽' },
                        { artistImage: '/0513/M00/4E/05/ChAKCGTbGjSAbSLJAADBhMuY890333.jpg', artistName: '永力兄弟' },
                        { artistImage: '/0513/M00/4E/05/ChAKCGTbGlSAPqiMAACzwkfti8Y810.jpg', artistName: '周密' },
                        { artistImage: '/0513/M00/DC/3E/ChAKFGTbGnmAKIXDAAG62ifYpZo287.jpg', artistName: '漏网之鱼' },
                        { artistImage: '/0513/M00/DC/3E/ChAKFGTbGrCAKiKGAAP7Q_DLlS0728.jpg', artistName: '河南说唱之神' },
                        { artistImage: '/0513/M00/DC/3E/ChAKFGTbGtOAPYkEAAJ3n_MEB6o722.jpg', artistName: '白鲨JAWS' },
                    ];
        },
    },
};
</script>
<style lang="scss" scoped>
.block2 {
    background: #111212;
    position: relative;
    color: #fff;
    min-height: 918px;
    text-align: center;

    .page-box-layout {
        position: relative;
        padding: 192px 0 178px;

        &::before {
            content: '';
            position: absolute;
            right: 0px;
            top: 0px;
            background: url('~@/assets/img/index/block2-bg.png') center no-repeat;
            background-size: cover;
            width: 1200px;
            height: 918px;
            z-index: 0;
        }

        h2 {
            font-size: 48px;
            font-weight: bold;
            color: #ffffff;
            line-height: 70px;
            position: relative;
            z-index: 1;
        }

        .title {
            font-size: 24px;
            font-weight: 500;
            color: #ffffff;
            line-height: 33px;
            margin-top: 24px;
            position: relative;
            z-index: 1;
        }

        .artist-list {
            margin-top: 88px;
            display: grid;
            position: relative;
            z-index: 1;
            grid-template-columns: repeat(4, 25%);

            .artist {
                margin-bottom: 64px;
            }

            .el-image {
                width: 140px;
                height: 140px;
                border-radius: 50%;
                overflow: hidden;
                // filter: grayscale(100%);
            }

            p {
                font-size: 14px;
                font-weight: 600;
                color: #ffffff;
                line-height: 20px;
                margin-top: 20px;
            }
        }

        .btn-box {
            position: relative;
            z-index: 1;

            .text {
                font-size: 16px;
                font-weight: bold;
                color: #ffffff;
                line-height: 24px;
                margin-bottom: 28px;
            }

            .btn {
                height: 54px;
                line-height: 54px;
                width: 242px;
                text-align: center;
                border-radius: 27px;
                background: $--color-base;
                font-weight: 600;
                color: #fff;
                display: inline-block;
            }
        }
    }
}
</style>
